import React from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import _ from 'lodash';

interface CustomInputProps {
    model: any;
    label?: string;
    id?: string;
    defaultValue?: string;
    helperText?: string;
}

const CustomInput: React.FC<CustomInputProps> = (props) => {
    return (
        <div className="custom-input">
            <TextField
                {...props}
                inputProps={{
                    max: _.get(props, 'max', 1000000),
                    min: _.get(props, 'min', -1000000)}}
            />
        </div>
    )
}

export default connect(null)(CustomInput);